import { render, staticRenderFns } from "./chat-button.vue?vue&type=template&id=12eacb81&scoped=true&"
import script from "./chat-button.vue?vue&type=script&lang=js&"
export * from "./chat-button.vue?vue&type=script&lang=js&"
import style0 from "./chat-button.vue?vue&type=style&index=0&id=12eacb81&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eacb81",
  null
  
)

export default component.exports